module.exports = __webpack_public_path__ + "static/img/sebastian_pictgrid63_960x887.1bd4b59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/sebastian_pictgrid63_960x887.jpg
// module id = Qj0X
// module chunks = 0